var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1760_13983)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6673 0.666504H2.66732C1.93398 0.666504 1.33398 1.2665 1.33398 1.99984V11.3332H2.66732V1.99984H10.6673V0.666504ZM12.6673 3.33317H5.33398C4.60065 3.33317 4.00065 3.93317 4.00065 4.6665V13.9998C4.00065 14.7332 4.60065 15.3332 5.33398 15.3332H12.6673C13.4007 15.3332 14.0007 14.7332 14.0007 13.9998V4.6665C14.0007 3.93317 13.4007 3.33317 12.6673 3.33317ZM12.6673 13.9998H5.33398V4.6665H12.6673V13.9998Z",
    fill: "#888888"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1760_13983"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.660ef33e032293603e00c79ee21acd38.svg";
export { ForwardRef as ReactComponent };